import { ShowFeatureQuery, ShowFeatureQueryVariables } from '@/typings/domain'
import apolloClient from './apolloClient'
import ShowFeatureGQL from './graphql/ShowFeature.graphql'

export function fetchShowFeature(key: string) {
  return apolloClient.query<ShowFeatureQuery, ShowFeatureQueryVariables>({
    query: ShowFeatureGQL,
    variables: { key },
    fetchPolicy: 'no-cache',
  })
}
